module.exports = __webpack_public_path__ + "media/images/niq-logo-on-black-724c45d4db02a50ba3f151783188b960.svg";